import { SearchOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import AutoCompleteImport from '@root/modules/Sellers/Import/components/AutoComplete';
import { AutoComplete, Col, Form, Input, Row } from 'antd';
import React, { useEffect, useState } from 'react';

interface Props {
  orderNumber?: string;
  buyerName?: string;
  recipientName?: string;
  orderDate?: string;
  buyerEmail?: string;
  shippingAddress?: string;
  detailAddress?: string;
  detailAddress2?: string;
  saleChannel?: string;
  recipientPhone?: string;
  street?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  canInput?: any;
  value?: string;
  onChange?: any;
  options?: any;
  onSelect?: any;
}

const InfoProReturn = ({
  orderNumber,
  buyerName,
  recipientName,
  orderDate,
  buyerEmail,
  shippingAddress,
  saleChannel,
  recipientPhone,
  street,
  detailAddress,
  detailAddress2,
  city,
  state,
  postalCode,
  country,
  canInput,
  value,
  onChange,
  options,
  onSelect
}: Props) => {
  const [form] = Form.useForm();

  form.setFieldsValue({
    orderNumber: orderNumber,
    buyerName: buyerName,
    recipientName: recipientName,
    orderDate: orderDate || '',
    buyerEmail: buyerEmail,
    shippingAddress: shippingAddress,
    detailAddress: detailAddress,
    detailAddress2: detailAddress2,
    saleChannel: saleChannel,
    recipientPhone: recipientPhone,
    street: street,
    city: city,
    state: state,
    postalCode: postalCode,
    country: country
  });

  return (
    <div className="infoDeli">
      <Form form={form} layout="vertical">
        <Row style={{ width: '95%' }}>
          <Col span={8} style={{ paddingRight: '20px' }}>
            {canInput ? (
              <Form.Item
                className="searchOrder"
                label="Order Number"
                name="orderNumber"
              >
                <AutoComplete
                  value={value}
                  options={options}
                  onSelect={onSelect}
                  // onSearch={onSearch}
                  onChange={onChange}
                ></AutoComplete>
                <SearchOutlined />
              </Form.Item>
            ) : (
              <Form.Item label="Order Number" name="orderNumber">
                <Input className="border-input" disabled />
              </Form.Item>
            )}
          </Col>
          <Col span={8} style={{ paddingRight: '20px' }}>
            <Form.Item label="Order Date" name="orderDate">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={8} style={{ paddingRight: '20px' }}>
            <Form.Item label="Online Website" name="saleChannel">
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ width: '95%' }}>
          <Col span={8} style={{ paddingRight: '20px' }}>
            <Form.Item label="Buyer Name" name="buyerName">
              <Input className="border-input" disabled />
            </Form.Item>
          </Col>
          <Col span={8} style={{ paddingRight: '20px' }}>
            <Form.Item label="Buyer Email" name="buyerEmail">
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ width: '95%' }}>
          <Col span={8} style={{ paddingRight: '20px' }}>
            <Form.Item label="Recipient Name" name="recipientName">
              <Input disabled />
            </Form.Item>
            <Form.Item label="Recipient Phone Number">
              <Form.Item name="recipientPhone">
                <Input disabled />
              </Form.Item>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Row style={{ width: '100%' }}>
              <Col span={8} style={{ paddingRight: '20px' }}>
                <Form.Item label="Shipping Country/Address" name="country">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={16} style={{ paddingRight: '20px' }}>
                <Form.Item label="　" name="detailAddress">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12} style={{ paddingRight: '20px' }}>
                <Form.Item name="detailAddress2">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12} style={{ paddingRight: '20px' }}>
                <Form.Item name="detailAddress">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ width: '100%' }}>
              <Col span={8} style={{ paddingRight: '20px' }}>
                <Form.Item name="city">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={8} style={{ paddingRight: '20px' }}>
                <Form.Item name="state">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={8} style={{ paddingRight: '20px' }}>
                <Form.Item name="postalCode">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default InfoProReturn;
